import { AudioHighlightMetadata } from '@modules/feedback/components/AudioType/types';
import { isSummaryHighlightMetadataType } from '@modules/feedback/components/AudioType/utils';

export const getNextHighlightToPlay = (
  highlightMetadata: AudioHighlightMetadata[],
  seek: number,
  buffer = 0,
  shouldContainSummary?: boolean,
) => {
  return highlightMetadata.find((highlight) => {
    const isInRange = highlight.startTime >= seek + buffer;

    if (shouldContainSummary) {
      return isInRange && isSummaryHighlightMetadataType(highlight);
    }

    return isInRange;
  });
};
